import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";
import notificationService from "./NotificationService";

export const exportService = {
    exportArcLogistics,
    exportCustomerInvoices,
    exportAdminOrders,
};
const baseUrl = `/api/exports`;

async function exportArcLogistics(dateDone: any): Promise<any> {
    const getObject = {
        url: `${baseUrl}/arclogistics-data?dateDone=${dateDone}`,
        filename: `ArcLogisticsExport${dateDone}.mdb`,
        customErrorMessage: `Failed to export ARC Logistics`,
    };
    await handleServiceRequest.download(getObject)
}

async function exportCustomerInvoices(startDate: any, endDate: any): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/invoice-data?dateDoneFirst=${startDate}&dateDoneLast=${endDate}`,
        filename: `PitneyBilling${startDate}-${endDate}.mdb`,
        customErrorMessage: `Failed to export customer invoices`,
    };
    await handleServiceRequest.download(getObject)
}


async function exportAdminOrders(startDate: any, endDate: any): Promise<any> {
    const getObject = {
        url: `${baseUrl}/admin-orders?startDate=${startDate}&endDate=${endDate}`,
        filename: `AdminOrders_${startDate}_${endDate}.csv`,
        customErrorMessage: `Failed to export admin orders report`,
    };
    await handleServiceRequest.download(getObject)
}

function downloadFileFromUrl(url: string, fileName: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}